import { isNil, uniqBy } from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'

const safeParseJSON = (jsonString) => {
  try {
    const fixedJsonString = jsonString
      .replace(/:\s*Infinity/g, ': null')  // Replace `Infinity` with `null`
      .replace(/:\s*-Infinity/g, ': null'); // Replace `-Infinity` with `null`

    let parsedData = JSON.parse(fixedJsonString);
    return parsedData; // Apply rounding
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
};

const RenderTracks = (props) => {
  const { tracks, mapReference, expandLeftToolbar, activeVendors, vendors, collapseLeftToolbar } = props
  if (mapReference === null) {
    return null
  }
  const vendorTracks = activeVendors.map(id => {
    return vendors[id] && vendors[id]['tracks'] && vendors[id]['objects']['tracks'] ?
      vendors[id]['objects']['tracks'].filter(track => isNil(track.mapObj) && !isNil(track.geoJson)) : []
  }),
    toAdd = tracks.filter(track => isNil(track.mapObj)).concat(vendorTracks.flat())
  if (toAdd.length > 0) {
    toAdd.forEach(track => {
      track['measureType'] = 'track'
      if (!track.geoJson) {
        return
      }

      // const geoJson = JSON.parse(track.geoJson),
      const geoJson = track?.geoJson && safeParseJSON(track.geoJson);
      if (!geoJson) {
        // console.error("Invalid geoJson:", track.geoJson);
      }
      const path = uniqBy(geoJson?.features[0]?.geometry?.coordinates, '0'),
        coords = path.map(coord => new google.maps.LatLng(coord[1], coord[0])),
        mapTrack = new google.maps.Polyline({
          name: track.name,
          map: mapReference,
          path: coords,
          strokeColor: 'red',
          strokeOpacity: 1,
          strokeWeight: 3,
          zIndex: 10,
          options: {
            draggable: false,
            clickable: true,
            cursor: 'pointer'
          },
          metadata: {
            id: track.id,
            type: 'tracks'
          }
        })
      track['mapObj'] = function () { return mapTrack }
      mapTrack.addListener('click', () => {
        collapseLeftToolbar()
        expandLeftToolbar({ dialog: 'edit', editable: track })
      })
    })
  }
  return null
}

const mapStateToProps = state => ({
  activeVendors: state.activeVendors,
  vendors: state.vendors,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  tracks: state.tracks
})

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderTracks)